import { useCallback, useEffect, useState } from "react";
import { fetchBuildings } from "../../../api/building";
import { Building } from "../../../generated/types";

/**
 * Bâtiments de l'élevage en cours de création.
 *
 * `createBuilding` ne renvoie pas l'identifiant du bâtiment créé : on relit la liste après
 * chaque ajout. Elle sert aussi au sélecteur de l'étape produits et au récapitulatif, d'où
 * le hook partagé.
 */
export const useBreedingBuildings = (breedingId: number) => {
  const [buildings, setBuildings] = useState<Building[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    const result = await fetchBuildings();
    setBuildings(
      result.Buildings.filter((building) => building.id_breeding === breedingId)
    );
    setError(result.error);
    setLoading(false);
  }, [breedingId]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { buildings, loading, error, reload };
};
